import _export from '../internals/export.js';
import createHtml from '../internals/create-html.js';
import stringHtmlForced from '../internals/string-html-forced.js';

var $ = _export;
var createHTML = createHtml;
var forcedStringHTMLMethod = stringHtmlForced; // `String.prototype.big` method
// https://tc39.es/ecma262/#sec-string.prototype.big

$({
  target: 'String',
  proto: true,
  forced: forcedStringHTMLMethod('big')
}, {
  big: function big() {
    return createHTML(this, 'big', '', '');
  }
});
